module.exports = __webpack_public_path__ + "static/media/cartoon.665731b3.png";